// Papel (Administrador ou Agente) e perfil de acesso sao duas escolhas
// separadas: o perfil so vale para Agente e substitui as permissoes padrao.
// O select unico misturava os dois e nao deixava isso claro.
export const rolePayload = ({ role, customRoleId }) => {
  if (role === 'agent' && customRoleId) {
    return { role: 'agent', custom_role_id: customRoleId };
  }
  return { role, custom_role_id: null };
};

// Registro antigo com administrador + perfil: a tela abre como Agente com o
// perfil, que e o que o backend grava ao salvar (a correcao do rebaixamento).
export const initialRole = ({ type, customRoleId }) =>
  customRoleId ? 'agent' : type || 'agent';
